import b from "../util/net.js";
import e from "../managers/braze-instance.js";
import ControlMessage from "./models/control-message.js";
import HtmlMessage from "./models/html-message.js";
import InAppMessage from "./models/in-app-message.js";
import InAppMessageButton from "./models/in-app-message-button.js";
import s from "../common/event-logger.js";
import { newInAppMessageFromJson as lt } from "./in-app-message-factory.js";
import { randomInclusive as tt } from "../util/math.js";
import t from "../models/request-result.js";
import r from "../../shared-lib/braze-shared-lib.js";
import u from "../managers/subscription-manager.js";
import pt from "../triggers/models/trigger.js";
import { validateValueIsFromEnum as F } from "../util/code-utils.js";
import { BRAZE_ACTION_URI_REGEX as J } from "../util/validation-utils.js";
import {
  containsPushPrimerBrazeAction as mt,
  containsUnknownBrazeAction as gt,
  getDecodedBrazeAction as _,
  ineligibleBrazeActionURLErrorMessage as ht,
  INELIGIBLE_BRAZE_ACTION_URL_ERROR_TYPES as ft
} from "../util/braze-actions.js";
import dt from "../Push/utils/push-utils.js";
export default class ge {
  constructor(t, s, i, r) {
    (this.vt = t),
      (this.j = s),
      (this.h = i),
      (this.v = r),
      (this.Se = new u()),
      e.jt(this.Se),
      (this.Oe = 1e3),
      (this.Re = 6e4);
  }
  Qe() {
    return this.Se;
  }
  Ue(t) {
    return this.Se.ut(t);
  }
  Ve() {
    return this.We;
  }
  Xe(t) {
    this.We = t;
  }
  Ye(e, i) {
    if (
      !F(
        InAppMessage.Me,
        i,
        `${i} is not a valid in-app message display failure`,
        "InAppMessage.DisplayFailures"
      )
    )
      return new t();
    const n = { trigger_ids: [e], error_code: i };
    return s.G(r.A.Ze, n);
  }
  G(e, i, n, o) {
    const a = new t();
    let l;
    if (e instanceof ControlMessage) l = { trigger_ids: [e.triggerId] };
    else {
      if (i === r.A.Ii || (e instanceof HtmlMessage && i === r.A.Ai)) {
        if (!e.k(o))
          return (
            r.D.info(
              "This in-app message has already received a click. Ignoring analytics event."
            ),
            a
          );
      } else if (i === r.A.Mi) {
        if (!e.R())
          return (
            r.D.info(
              "This in-app message has already received an impression. Ignoring analytics event."
            ),
            a
          );
      }
      l = this.zi(e);
    }
    return null == l ? a : (null != n && (l.bid = n), s.G(i, l));
  }
  ki(e, i) {
    const n = new t();
    if (!e.k())
      return (
        r.D.info(
          "This in-app message button has already received a click. Ignoring analytics event."
        ),
        n
      );
    const o = this.zi(i);
    return null == o
      ? n
      : e.id === InAppMessageButton.$i
      ? (r.D.info(
          "This in-app message button does not have a tracking id. Not logging event to Braze servers."
        ),
        n)
      : (null != e.id && (o.bid = e.id), s.G(r.A.Ai, o));
  }
  Bi(t) {
    if (!(t instanceof InAppMessage)) return;
    const e = t => {
        const e = _(t);
        return gt(e)
          ? ht(ft.Ei, "In-App Message")
          : mt(e) && !dt.Gi()
          ? ht(ft.Ni, "In-App Message")
          : void 0;
      },
      s = t.buttons;
    let i;
    for (const t of s)
      if (
        t.clickAction === InAppMessage.ClickAction.URI &&
        J.test(t.uri) &&
        ((i = e(t.uri)), i)
      )
        return i;
    return t.clickAction === InAppMessage.ClickAction.URI && J.test(t.uri)
      ? e(t.uri)
      : void 0;
  }
  qi(t, e, s, i) {
    let n = this.vt.Oi(!1, !1);
    (n = this.vt.Ps(n)),
      (n.template = { trigger_id: t.triggerId, trigger_event_type: e }),
      null != s && (n.template.data = s.Pi());
    const o = this.vt.Bs(n);
    this.vt.Gs(n, () => {
      b.Hs({
        url: `${this.vt.Ks()}/template/`,
        data: n,
        headers: o,
        S: e => {
          if (!this.vt.Os(n, e, o))
            return (
              this.Ye(t.triggerId, InAppMessage.Me.Ri),
              void ("function" == typeof t.Hi && t.Hi())
            );
          if ((this.vt.Qs(), null == e || null == e.templated_message))
            return void this.Ye(t.triggerId, InAppMessage.Me.Ri);
          const s = e.templated_message;
          if (s.type !== pt.Ki.Ji)
            return void this.Ye(t.triggerId, InAppMessage.Me.Li);
          const i = lt(s.data);
          if (null == i) return void this.Ye(t.triggerId, InAppMessage.Me.Li);
          let a = this.Bi(i);
          if (a)
            return r.D.error(a), void ("function" == typeof t.Hi && t.Hi());
          "function" == typeof t.Qi
            ? t.Qi(i)
            : this.Ye(t.triggerId, InAppMessage.Me.Ri);
        },
        error: r => {
          let n = `getting user personalization for message ${t.triggerId}`;
          if (new Date().valueOf() - t.Ui > t.Vi)
            this.Ye(t.triggerId, InAppMessage.Me.Ri);
          else {
            const r = Math.min(t.Vi, this.Re),
              o = this.Oe;
            null == i && (i = o);
            const a = Math.min(r, tt(o, 3 * i));
            (n += `. Retrying in ${a} ms`),
              setTimeout(() => {
                this.qi(t, e, s, a);
              }, a);
          }
          this.vt.Vs(r, n);
        }
      });
    });
  }
  zi(t) {
    if (null == t.triggerId)
      return (
        r.D.info(
          "The in-app message has no analytics id. Not logging event to Braze servers."
        ),
        null
      );
    const e = {};
    return null != t.triggerId && (e.trigger_ids = [t.triggerId]), e;
  }
}
